module.exports = __webpack_public_path__ + "img/Reset.9241e0f4.svg";